import React from 'react';
import { ColumnConfig } from '@components/design/migrated/Table';
import { CategoryGroup, PerformanceAnalysisboardPg } from '@models/PerformanceAnalysisboard';
import PerformanceAnalysisTableCell from '../performance-analysis-table-cell/PerformanceAnalysisTableCell';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { Filters, ShareType } from '@utils/pageConfig/Types';

interface Props {
  performanceAnalysisboardPg: PerformanceAnalysisboardPg;
  columns: ColumnConfig[];
  isStickyRow?: boolean;
  sortedColumn: string;
  className?: string;
  selectedGrowthType: GrowthTypes;
  selectedShareType: ShareType;
  countries: Filters;
  currencySymbol: string;
}

export const getKeysByOrder = (columns: ColumnConfig[]): string[] => columns.map(({ headerKey }) => headerKey);

export const isCategoryGroup = (type: string): boolean => type === CategoryGroup;

const PerformanceAnalysisTableRow: React.FC<Props> = ({
  performanceAnalysisboardPg,
  columns,
  isStickyRow,
  sortedColumn,
  className,
  selectedGrowthType,
  selectedShareType,
  countries,
  currencySymbol,
}) => {
  const headerKeys = getKeysByOrder(columns);

  return (
    <tr className={className}>
      {headerKeys.map((headerKey) => {
        return (
          <PerformanceAnalysisTableCell
            key={headerKey}
            headerKey={headerKey}
            performanceAnalysisboardPg={performanceAnalysisboardPg}
            isStickyRow={isStickyRow}
            isCategoryGroup={isCategoryGroup(headerKey)}
            sortedColumn={sortedColumn}
            selectedGrowthType={selectedGrowthType}
            selectedShareType={selectedShareType}
            countries={countries}
            currencySymbol={currencySymbol}
          />
        );
      })}
    </tr>
  );
};

export default PerformanceAnalysisTableRow;
